module.exports = __webpack_public_path__ + "img/hips.3f80b0ed.png";